import {
    connect,
} from 'react-redux';
import actions from "@shared/actions";
import {getRooms} from "@shared/selector";
import {EntityScene} from "./EntityScene";

class RoomScene extends EntityScene {
    constructor(props) {
        super(props, 'room');
    }
}

const mapStateToProps = state => ({
    rooms: getRooms(state),
});

const mapDispatchToProps = {
    onInfopointEditAction: actions.data.infopoint.edit,
    onRoomEditAction: actions.data.room.edit,
    onShowStandardDialog: actions.dialog.standard.start,
};

export default connect(mapStateToProps, mapDispatchToProps)(RoomScene);
